import { Api } from '../../api';
import {
  errorToast,
  useOutsideClick,
  getFilterKey,
  isSuperAdmin,
  isCopanySuperAdmin,
  contentApprovalStatusColors,
  getPathForSurvey,
  successToast,
  getLocalStorageItem
} from '../../utils/helper';
import { Dialog, Transition } from '@headlessui/react';
import Table from '../../component/common/Table';
import React, { Fragment } from 'react';
import { useRef, useState, useEffect } from 'react';

import SearchInput from '../../component/common/Input/SearchInput';
import { Helmet } from 'react-helmet';
import SelectMenu from '../../component/common/SelectMenu';
import {
  APPROVAL_STATUS_DROPDOWN,
  CONTENT_APPROVAL_STATUS,
  CONTENT_TYPE,
  PER_PAGE
} from '../../utils/constants';
import { FunnelIcon } from '@heroicons/react/24/outline';
import { ChevronDownIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { CompanyApi } from '../../api/companyApi';
import moment from 'moment';
import CommonPopover from '../../component/common/popover';
import { useNavigate } from 'react-router-dom';
import ConfirmPopup from '../../component/common/modals/ConfirmPopup';
import RejectPopup from '../../component/common/modals/RejectPopup';
import Loader from '../../component/common/Loader';
// import Topbar from '../PulseSurvey/Topbar';
import Topbar2 from './Topbar';
import Pagination from '../../component/common/Pagination/Pagination';
import InfoPopup from '../../component/common/InfoPopup';
//import InfoTab from '../../component/common/info/InfoTab';
import { getPathForInstantSupport } from '../../utils/helper';
import imgHeadphone from '../../assets/images/instantsupport-headphones.png';
import { TableCard } from '../../component/common/designSystem';

function B2BInstantSupportTable(props) {
  const wrapperRef = useRef(null);
  const cancelButtonRef = useRef(null);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortOrder, setSortOrder] = useState(-1);
  const [sortBy, setSortBy] = useState('');
  const [filterQuery, setFilterQuery] = useState('');
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [updatedList, setUpdatedList] = useState([]);

  const [InstantSupportUsersList, setInstantSupportUsersList] = useState([]);
  const [cannotActiveMoreUsersOpen, setcannotActiveMoreUsersOpen] = useState(false);
  const userData = getLocalStorageItem('userData') && JSON.parse(getLocalStorageItem('userData'));
  const companyTotalSeats = getLocalStorageItem('companyTotalSeats') && JSON.parse(getLocalStorageItem('companyTotalSeats'));
  const companyUsedSeats = getLocalStorageItem('companyUsedSeats') && JSON.parse(getLocalStorageItem('companyUsedSeats'));
  const { userType, companyId } = JSON.parse(localStorage.getItem('userData'));
  const [filterCriteria, setFilterCriteria] = useState({
    companySubscription: ''
  });

  const pages = [
    { name: 'Instant Support', href: `/${userData.slug}/instant-support`, current: true }
  ];

  const columns = [
    {
      title: 'Name',
      key: 'name',
      sortable: false,
      type: 'text',
      align: 'left'
    },
    {
      title: 'Voice Calls',
      key: 'voiceCalls',
      sortable: false,
      type: 'number',
      align: 'left'
    },
    {
      title: 'Video Calls',
      key: 'videoCalls',
      sortable: false,
      type: 'number',
      align: 'left'
    },
    {
      title: 'Talk Time',
      key: 'talkedTime',
      type: 'number',
      sortable: false,
      align: 'center'
    },
    {
      title: 'Last Used',
      key: 'lastUsedDate',
      type: 'number',
      sortable: false,
      align: 'center'
    },
    {
      title: 'Status',
      key: 'instantSupportStatus',
      type: 'text',
      sortable: false,
      align: 'left'
    }
  ];

  const handlePagination = (pageNumber, pageSize, searchKey, sortBy, sortOrder) => {
    setLoader(true);
    // Api.getAllCompanies(pageNumber, pageSize, searchKey, sortBy, sortOrder).then((response) => {
    //   setLoader(false);
    //   console.log("temp res da",response.data.data);
    //   if (response?.data) {
    //     if (response?.data?.data) {
    //       setUsersList(
    //         response?.data?.data?.map((item) => ({
    //           ...item,
    //           name: item?.company_name,
    //           email: item?.company_email,
    //           profile: item?.company_logo
    //         }))
    //       );
    //       setCurrentPage(pageNumber);
    //       setTotalCount(response?.data?.meta?.totalRecords);
    //       setLoader(false);
    //     } else {
    //       setLoader(false);
    //       errorToast('Something went wrong, please try again later !');
    //     }
    //   } else if (response?.code === 401) {
    //     errorToast(response?.message);
    //     setLoader(false);
    //   } else if (response?.data?.meta?.code === 0) {
    //     setLoader(false);
    //     setCurrentPage(1);
    //     setUsersList([]);
    //     setTotalCount(0);
    //     errorToast(response?.data?.meta?.message);
    //   } else {
    //     setLoader(false);
    //   }
    // });

    CompanyApi.getInstantSupportList(pageNumber, pageSize, companyId).then((response) => {
      console.log('res data for inslist', response?.data?.data);

      if (response?.data) {
        if (response?.data?.data) {
          setInstantSupportUsersList(
            response?.data?.data?.map((item) => ({
              ...item,
              name: item?.name
            }))
          );
          setCurrentPage(pageNumber);
          setTotalCount(response?.data?.meta?.totalRecords); // response?.data?.meta?.totalRecords
          setLoader(false);
        } else {
          setLoader(false);
          errorToast('Something went wrong, please try again later !');
        }
      } else if (response?.code === 401) {
        errorToast(response?.message);
        setLoader(false);
      } else if (response?.data?.meta?.code === 0) {
        setLoader(false);
        setCurrentPage(1);
        setUsersList([]);
        setTotalCount(0);
        errorToast(response?.data?.meta?.message);
      } else {
        setLoader(false);
      }
    });
  };

  //   const handleSortBy = (sortByValue) => {
  //     setSortBy(sortByValue);
  //     if (sortByValue === sortBy) {
  //       let tempSortOrder = sortOrder === 1 ? -1 : 1;
  //       setSortOrder(tempSortOrder);
  //       handlePagination(currentPage, selectedPerPage?.value, searchTerm, sortByValue, tempSortOrder);
  //     } else {
  //       setSortOrder(1);
  //       handlePagination(currentPage, selectedPerPage?.value, searchTerm, sortByValue, 1);
  //     }
  //   };

  useEffect(() => {
    if (searchTerm) {
      let searchParam = searchTerm.trim();
      const delayDebounceFn = setTimeout(() => {
        handlePagination(1, selectedPerPage?.value, searchParam, sortBy, sortOrder);
      }, 800);

      return () => clearTimeout(delayDebounceFn);
    } else {
      handlePagination(1, 10, '', sortBy, sortOrder);
    }
  }, [searchTerm]);

  const handlePerPage = (perPage) => {
    setSelectedPerPage(perPage);
    handlePagination(1, perPage.value, searchTerm, sortBy, sortOrder);
  };

  // useOutsideClick(wrapperRef, () => {
  //   if (showFilterModal) setShowFilterModal(!showFilterModal);
  // });

  const refreshTable = () => handlePagination(1, selectedPerPage?.value, '', sortBy, sortOrder);

  //   const filterHandler = (data, key) => {
  //     setFilterCriteria((prevData) => ({
  //       ...prevData,
  //       [key]: data
  //     }));
  //     let clone = JSON.parse(JSON.stringify(filterCriteria));
  //     const newData = { ...clone, [key]: data };
  //     let tempFilterQuery = [];
  //     Object.keys(newData).forEach(function (key) {
  //       if (newData[key]?.value?.toString()) {
  //         tempFilterQuery.push(`&${key}=${newData[key]?.value}`);
  //       }
  //     });
  //     let query = tempFilterQuery?.toString()?.replaceAll(',', '');
  //     setFilterQuery(query);
  //     handlePagination(1, selectedPerPage.value, searchTerm, query, sortBy, sortOrder);
  //   };

  const resetHandler = () => {
    setFilterCriteria({
      companySubscription: ''
    });
    setFilterQuery('');
    setShowFilterModal(false);
    handlePagination(1, selectedPerPage.value, searchTerm, '', sortBy, sortOrder);
  };

  // Update your handleStatusChange function
  const handleStatusChange = (event, id, status) => {
    if (companyUsedSeats === companyTotalSeats && status === 'Active') {

      console.log('OPEN THE DIALOG TO SAY YOU CANT ACTIVATE MORE USED. UPGRADE IT  ');

      setcannotActiveMoreUsersOpen(true);
      return;
    }
    props.setLoader(true);
    console.log('activate-deactive', status, 'and the id : ', id);

    const newStatus = status;
    const updatedList = InstantSupportUsersList.map((user) =>
      user._id === id ? { ...user, instantSupportStatus: newStatus } : user
    );

    setInstantSupportUsersList(updatedList);
    const reqBodyForUserStatus = {
      companyId: companyId,
      userId: id,
      status: status,
      toggle: false
    };

    CompanyApi.postInstnatSupportUserStatus(reqBodyForUserStatus)
      .then((response) => {
        if (response?.status === 200) {
          console.log('response from active-deactivate API :', response?.data?.data);
          // Trigger refresh in parent component after successful status change
          props.triggerRefresh();
        } else {
          console.log('Some error active-deactivate API');
          props.setLoader(false);
        }
      })
      .catch((error) => {
        console.error('Error in status change API:', error);
        props.setLoader(false);
      });
  };

  const rowsData = InstantSupportUsersList.map((item) => {
    return {
      ...item,
      name: (
        <>
          <div>
            {item.name
              .split(' ')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
              .join(' ')}
          </div>
        </>
      ),
      instantSupportStatus: (
        <>
          <div>
            {/* CommonPopover */}
            <CommonPopover
              label={
                <>
                  <span>{item.instantSupportStatus === 'Active' ? 'Active' : 'Disabled'}</span>
                  {/* {item.instantSupportStatus === 'Assign' ? (
                    <ChevronDownIcon className="w-5 h-5" />
                  ) : (
                    <></>
                  )} */}
                  <ChevronDownIcon className="w-5 h-5" />
                </>
              }
              className={`w-29 min-w-28 px-4 py-1 text-xs inline-block rounded-full border mx-auto cursor-pointer appearance-none ${
                item.instantSupportStatus === 'Active'
                  ? 'bg-[#DDF2BF] text-[#438038] border-[#438038]'
                  : 'bg-[#F9F2F5] text-[#BF3261] border-[#BF3261]'
              }`}
              contentClassName={`w-[155px] p-5`}
            >
              {item.instantSupportStatus === 'Active' ? (
                <ul className={`text-base space-y-2`}>
                  <li>
                    <button onClick={(e) => handleStatusChange(e, item._id, 'InActive')}>
                      Disabled
                    </button>
                  </li>
                </ul>
              ) : (
                <>
                  <ul className={`text-base space-y-2`}>
                    <li>
                      <button onClick={(e) => handleStatusChange(e, item._id, 'Active')}>
                        Active
                      </button>
                    </li>
                  </ul>
                </>
              )}
            </CommonPopover>
          </div>
        </>
      ),
      talkedTime: (
        <div>
          {item.talkedTime ? `${Math.floor(item.talkedTime / 60)}h:${item.talkedTime % 60}m` : `0m`}
        </div>
      ),
      lastUsedDate: (
        <div>{item.lastUsedDate ? moment(new Date(item.lastUsedDate)).format('MMM D, YYYY') : 'N/A'}</div>
      )
    };
  });

  return (
    <>
      <div className="relative sm:mt-6 mt-4">
        {loader ? <Loader /> : null}
        {/* <Breadcrumb pageList={pages} /> */}
      </div>

      <div className="relative lg:mb-[45px]">
        <TableCard
          pagination={{
            currentPage: currentPage,
            totalCount: totalCount,
            pageSize: selectedPerPage?.value,
            onPageChange: (page) =>
                  handlePagination(page, selectedPerPage?.value, searchTerm, sortBy, sortOrder),
            onPageSizeChange: (size) =>
              handlePerPage(PER_PAGE.find((o) => o.value === size) || PER_PAGE[0]),
            pageSizeOptions: PER_PAGE.map((o) => o.value)
          }}
        >
          <Table
            columns={columns}
            data={rowsData}
            name={'company_table'}
            bottomBorder={totalCount > selectedPerPage?.value}
            // setSortBy={(sort) => handleSortBy(sort)}
            refreshTable={refreshTable}
            loader={loader}
            r
          />
        </TableCard>

        <div>
          {InstantSupportUsersList.length > 0 && !loader ? (
            <>
              
            </>
          ) : (
            <></>
          )}
        </div>
        {/* Dialoge for deactivate feature */}
        <Transition.Root appear show={cannotActiveMoreUsersOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50"
            initialFocus={cancelButtonRef}
            onClose={setcannotActiveMoreUsersOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
            <div className="fixed inset-0 z-50 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-3xl bg-white dark:bg-gray-800 text-left transition-all sm:my-8 sm:w-full sm:max-w-[512px]">
                    <div className="bg-white dark:bg-gray-800 p-6 border border-gray-300 dark:border-shoorah-darkBorder rounded-lg">
                      {/* <div className="flex justify-between items-center mb-4">
                              <p className="text-xl font-normal">Add On</p>
                              
                            </div> */}
                      <center>
                        <div className="font-normal text-base">
                        You've reached the maximum number of active users. To activate more, consider upgrading number of users and unlocking additional user slots.
                        </div>
                      </center>

                      <div className="flex items-center justify-center w-full">
                        <button
                          onClick={() => {
                            setcannotActiveMoreUsersOpen(false);
                          }}
                          className="btn-primary w-full mx-1 sm:w-[140px] mt-8"
                        >
                          Okay
                        </button>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      </div>
    </>
  );
}

export default B2BInstantSupportTable;
